/**
 * Невозможно сделать текстовые значения энамки в lowerCamelCase, т.к. в балансере используется CamelCase,
 * а в billing-subscriptions — lowerCamelCase. Так как ручек балансера больше, чем ручек подписок, проще
 * придерживаться CamelCase.
 */
export enum EBuyPackageStatus {
  Confirm = 'Confirm',
  Ok = 'Ok',
  OkWithDeposit = 'OkWithDeposit',
  NotEnoughMoney = 'NotEnoughMoney',
  TariffNotAvailable = 'TariffNotAvailable',
  Error = 'Error',
  Loading = 'Loading',
}
